import styled from "styled-components";
import { useState } from "react";
import { Card, Container } from "react-bootstrap";
import { showError } from "../../services/toast-service";
import { CustomCard, PageHeading } from "../common-styling";
import { useTranslation } from "react-i18next";
import { Spinner } from "react-bootstrap";
import { getAppointmentConfirmationAnalysis } from "../../services/api-declaration";
import {
  DATE_FILTERS,
  PICKER_OPT_A,
  PICKER_LAYOUT
} from "../date-range-pickers/picker-helper";
import DateSelectorToolbar from "../date-range-pickers/date-selector-toolbar";
import BarChart from "../charts/barChart";

const ChartDiv = styled.div`
  height: 500px;
`;
const LeadAppointments = () => {
  const { t } = useTranslation();
  const [appointmentInsights, setAppointmentInsights] = useState();
  const [appointmentInsightsLoading, setAppointmentInsightsLoading] =
    useState(false);

  const fetchAppointmentAnalytics = async (queryParams) => {
    if (appointmentInsightsLoading) return;
    setAppointmentInsightsLoading(true);
    try {
      const resp = await getAppointmentConfirmationAnalysis(queryParams);
      if (resp) {
        setAppointmentInsights(resp.data.data);
        setAppointmentInsightsLoading(false);
      }
    } catch (err) {
      console.log(err);
      showError(err.response.data.message);
      setAppointmentInsightsLoading(false);
    }
  };
  const fetchData = ({ startDate, endDate }) => {
    fetchAppointmentAnalytics({
      startDate,
      endDate
    });
  };

  return (
    <>
      <div>
        <PageHeading>Terminbestätigung</PageHeading>

        <Container fluid className="mt-4 px-0">
          <CustomCard>
            <Card.Header className="mb-2 py-1 d-flex justify-content-between">
              <div className="fw-bold align-self-center">
                {t("leadpannel.appointmentChartTitle")}
              </div>
              <div>
                <DateSelectorToolbar
                  options={PICKER_OPT_A}
                  fetchData={fetchData}
                  layout={PICKER_LAYOUT.DROPDOWN}
                  defaultSelected={DATE_FILTERS.TODAY}
                />
              </div>
            </Card.Header>
            <ChartDiv>
              {appointmentInsightsLoading ? (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <Spinner animation="border" />
                </div>
              ) : (
                <BarChart
                  columnWidth={"25%"}
                  colors={[
                    "#008ffbd9",
                    "#008ffbd9",
                    "#008ffbd9",
                    "#008ffbd9",
                    "#20c997",
                    "#dc3545",
                    "#808080",
                    "#808080"
                  ]}
                  series={[
                    {
                      data: [
                        appointmentInsights?.openLeadAppointments,
                        appointmentInsights?.handledLeads,
                        appointmentInsights?.callMade,
                        appointmentInsights?.notReached,
                        appointmentInsights?.confirm,
                        appointmentInsights?.cancel,
                        appointmentInsights?.postpone,
                        appointmentInsights?.notHandled
                      ],
                      name: "Count"
                    }
                  ]}
                  distributed
                  categories={[
                    t("leadpannel.openAppointments"),
                    t("leadpannel.handledLeads"),
                    t("leadpannel.callsMade"),
                    t("leadpannel.notReached"),
                    t("leadpannel.confirm"),
                    t("leadpannel.cancel"),
                    t("leadpannel.postpone"),
                    t("leadpannel.notHandled")
                  ]}
                />
              )}
            </ChartDiv>
          </CustomCard>
        </Container>
      </div>
    </>
  );
};
export default LeadAppointments;
